import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconMagnifier = props => (
  <SvgIcon {...props} viewBox="0 0 16.65 18">
    <path fillRule="evenodd" d="m11.9 11.321h-0.7521l-0.2666-0.2779c0.933-1.1734 1.495-2.6965 1.495-4.3535 0-3.6947-2.7706-6.6895-6.1882-6.6895s-6.1878 2.9948-6.1878 6.6895 2.7702 6.6896 6.1878 6.6896c1.5327 0 2.9416-0.6072 4.0269-1.6158l0.257 0.2882v0.813l4.76 5.136 1.418-1.533-4.75-5.146zm-5.712 0.0002c-2.3704 0-4.2839-2.0686-4.2839-4.6312s1.9135-4.6312 4.2839-4.6312 4.2839 2.0686 4.2839 4.6312-1.9135 4.6312-4.2839 4.6312z" />
  </SvgIcon>
);

export default IconMagnifier;



// WEBPACK FOOTER //
// ./src/components/icons/IconMagnifier.js